// extracted by mini-css-extract-plugin
export default {"tooltip":"fT-z","arrow":"gT-z"};